angular.module('bmsApp')
	.controller('ApplicationCtrl', function ($scope,
											 AuthService,
											 $log,
											 $state,
											 Idle,
											 $rootScope,
											 notify,
											 notificationService,
											 ScheduleSvc,
											 GeocodeSvc,
											 NotificationSvc,
											 InstanceSvc,
											 $interpolate,
											 $window,
											 $location,
											 $cookies,
											 $ngBootbox,
											 ngTableDefaults,
											 ChangeLogSvc,
											 TicketSvc,
											 $mdDialog,
											 $modal) {

		$scope.menuOpen = false;
		/* Global configuration settings ----------------------------------------------------------*/
		notify.config({
			container: 'body',
			startTop: 60,
			duration: 5000,
			templateUrl: 'ng/layout/partials/gc-notify-template-gmail.html'
		});

		/* set default ngTable params and settings */
		ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, {});
		ngTableDefaults.settings = angular.extend({}, ngTableDefaults.settings, {
			defaultSort: 'asc'
		});

		/* User related functionality --------------------------------------------------------------*/
		$scope.setCurrentUser = function (user) {
			$scope.currentUser = user;
		};
		$scope.isAuthenticated = function () {
			return AuthService.isAuthenticated();
		};

		$scope.loggedInUser = function () {
			return AuthService.getUser();
		};

		// Reinstate the session if user refreshed the page manually
		// AuthService.reinstate();
		// if (AuthService.isAuthenticated()) {
		// 	$scope.setCurrentUser(AuthService.getUserInfo());
		// 	Idle.watch(); // restart the session timeout
		// }
		$scope.logout = function () {
			$state.go('logout');
			return false;
		};
		$rootScope.$on("loggedIn", function () {
			Idle.watch();
			// ChangeLogSvc.checkUnread().then((response) => {
			// 	$scope.unreadChangeLog = response.data.count;
			// });
		});


		$rootScope.$on("logout", function () {
			// $scope.logout();
		});

		/* Change log ------------------------------------------------------------------------------------*/
		$scope.showChangeLog = function () {
			ChangeLogSvc.showModal().then(() => {
				ChangeLogSvc.read();
				$scope.unreadChangeLog = 0;
			});
		};



		$scope.raiseIssueDialog = function() {
			TicketSvc.openRaiseTicketDialog();
		};

		// Notifications -----------------------------------------------------------------------------------------------
		function getAndDisplayNotifications(NotificationSvc) {
			if (!$scope.isAuthenticated()) {
				return false;
			}
			NotificationSvc.getNotifications()
				.then(function (response) {
					displayScheduleNotifications(response.data.schedule);
					angular.forEach(response.data.notifications, function (Notification) {
						var buttons = [];
						if (Notification.system_type == 'missing_geocode') {
							var fixButton = {
								text: "Fix",
								addClass: "",
								click: function (notice, value) {
									$state.go('main.geocode');
									notice.remove();
								}
							};
							buttons.push(fixButton);
						}
						else if (Notification.system_type == 'outstanding_fees') {
							var viewFeesButton = {
								text: "View fees",
								addClass: "",
								click: function (notice, value) {
									$state.go('main.fees.index');
									notice.remove();
								}
							};
							buttons.push(viewFeesButton);
						}
						else if (Notification.system_type == 'new_ecom_order') {
							let viewButton = {
								text: 'View orders',
								addClass: '',
								click: (notice, value) => {
									$state.go('main.dashboard.ecommerce');
									notice.remove();
								},
							};
							buttons.push(viewButton);
						}
						else {
							var closeButton = {
								text: "Dismiss",
								promptTrigger: true,
								click: function (notice, value) {
									if (Notification.persistent) {
										NotificationSvc.dismiss({id: Notification.id});
									}
									notice.remove();
								}
							};
						}
						if (Notification.persistent || Notification.system_type == 'missing_geocode' || Notification.system_type == 'outstanding_fees') {
							var snoozeButton = {
								text: "Snooze (24 HR)",
								promptTrigger: true,
								click: function (notice, value) {
									notice.remove();
								}
							};
							buttons.push(snoozeButton);
						}
						buttons.push(closeButton);
						var notifyOptions = {
							title: Notification.title,
							text: Notification.message,
							hide: false,
							type: Notification.type,
							confirm: {
								confirm: true,
								buttons: buttons
							},
							buttons: {
								closer: false,
								sticker: false
							}
						};
						notificationService.notify(notifyOptions);
					});
				})
			;
		}

		function displayScheduleNotifications(scheduleNotifications) {
			angular.forEach(scheduleNotifications, function (schedule) {
				if (scheduleDisplay.activity.indexOf(schedule.id) === -1) {
					var title = '';
					var text = '';
					if (schedule.type == 'Activities\ActivitySchedule') {
						title = '<b>Activities\Activity Reminder</b>';
						text += "<div style='color:#a80e0f;font-size:12px;'>";
						text += "<div>From: " + moment(schedule.activity.activity_start_date).format($scope.config.format.date.amMediumDateTime) + "</div>";
						text += "<div>To: " + moment(schedule.activity.activity_end_date).format($scope.config.format.date.amMediumDateTime) + "</div>";
						if (schedule.activity.activity_subject != '')
							text += "<div>Subject: <i>" + schedule.activity.activity_subject + "</i></div>";
						if (schedule.activity.activity_location != '')
							text += "<div>Location: <i>" + schedule.activity.activity_location + "</i></div>";
						if (schedule.activity.employee)
							text += "<div>Employee: <a href=\"#/employee/" + schedule.activity.employee.id + "\">" + schedule.activity.employee.display_name + "</a></div>";
						if (schedule.activity.customer)
							text += "<div>Customer: <a href=\"#/crm/customer/" + schedule.activity.customer.id + "\">" + schedule.activity.customer.display_name + "</a></div>";
						if (schedule.activity.activity_detail != '')
							text += "<br><div>" + schedule.activity.activity_detail + "</div>";
						text += "</div>";
					}
					notificationService.notify({
						title: title,
						text: text,
						hide: false,
						confirm: {
							confirm: true,
							buttons: [
								{
									text: "Dismiss",
									addClass: "",
									promptTrigger: true,
									click: function (notice, value) {
										NotificationSvc.dismiss(schedule)
											.then(function (response) {

											}, function (error) {
												notify({
													message: 'Failed to dismiss schedule',
													classes: 'error'
												});
											})
											.finally(function () {
												notice.remove();
												var index = scheduleDisplay.activity.indexOf(schedule.id);
												scheduleDisplay.activity.splice(index, 1);
											});
									}
								},
								{
									addClass: "hidden"
								}
							]
						},
						buttons: {
							closer: false,
							sticker: false
						}
					});
					scheduleDisplay.activity.push(schedule.id);
				}
			});
		}

		getAndDisplayNotifications(NotificationSvc);


		/* Idling ----------------------------------------------------------------------------------*/
		$scope.$on('IdleStart', function () {
			notify({
				message: 'You session is expiring in 2 minutes due to inactivity..'
			});
		});
		$scope.$on('IdleWarn', function (e, countdown) {
			// follows after the IdleStart event, but includes a countdown until the user is considered timed out
			// the countdown arg is the number of seconds remaining until then.
			// you can change the title or display a warning dialog from here.
			// you can let them resume their session by calling Idle.watch()
			if (countdown == 30) {
				notify({
					message: 'Yikes! Just 30 seconds until we log you out due to inactivity'
				});
			}
		});

		$scope.$on('IdleTimeout', function () {
			// the user has timed out (meaning idleDuration + timeout has passed without any activity)
			// this is where you'd log them
			$state.go('logout');
		});

		$scope.$on('IdleEnd', function () {
			// the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
		});

		var scheduleDisplay = {
			activity: []
		};

		$scope.missingGeocodesChecked = false; // used for tracking whether geocode reminder has been displayed

		$scope.$on('Keepalive', function () {
			// do something to keep the user's session alive
			$cookies.last_active = new Date();
			if (AuthService.isAuthenticated() /*&& Visibility.hidden() === false */) {
				// Get notifications
				getAndDisplayNotifications(NotificationSvc);
			}
		});

		Highcharts.setOptions({
			lang: {
				decimalPoint: '.',
				thousandsSep: ','
			}
		});

		$scope.openNav = function() {
			if ($scope.menuOpen) {
				$scope.closeNav();
			}
			else {
				document.getElementById("mySidenav").style.width = "100%";
				document.getElementById("mySidenav").style.zIndex = "99999";

				// document.getElementById("working-space").style.marginLeft = "90%";
				$scope.menuOpen = true;
			}
		};

		$scope.closeNav = function() {
			document.getElementById("mySidenav").style.width = "0";
			document.getElementById("mySidenav").style.zIndex = "0";
			// document.getElementById("working-space").style.marginLeft = "0";
			$scope.menuOpen = false;
		};

		$scope.isState = $state.is;
		
	});
